import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import { Select } from 'mailup-web-components'

import { searchState } from '../../recoil/state/search'

export const InputFilterByField = ({ onChange }) => {
  const intl = useIntl()

  const [{ filterByField }, setSearch] = useRecoilState(searchState)

  const handleChange = value => {
    setSearch(prev => {
      onChange(value)
      return { ...prev, filterByField: value }
    })
  }

  const { current: options } = useRef([
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.LastUpdateHeaderColumn'
      }),
      value: 'LastUpdated'
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.LastSentHeaderColumn'
      }),
      value: 'LastSent'
    }
  ])

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleChange}
      value={filterByField}
      data-mu-test='search-field__filter-by'
      className='test-search-field__filter-by'
    />
  )
}

InputFilterByField.propTypes = {
  onChange: PropTypes.func
}
